import { PriceVariant } from '@/integrations/crystallize/types';
import {
  PriceVariantFragment,
  SubscriptionPeriodPricingFragment,
} from '@/integrations/crystallize/__gql-codegen-types/catalogue/graphql';
import { useLocalization } from '../providers/localizationProvider';
import {
  getFormattedPrice,
  getFormattedPriceForSubscriptionPeriod,
} from '../utils/currency-helpers';

export type FormatCurrency = (
  value?: number | PriceVariant | PriceVariantFragment | null,
  options?: Intl.NumberFormatOptions,
) => string;

export const useCurrencyFormatter = () => {
  const context = useLocalization();

  const formatCurrency: FormatCurrency = (value, options) =>
    getFormattedPrice(context.locale, value, {
      ...options,
      // Add the currency from context.areaVariables if it's not defined in options
      ...(options?.currency ? {} : { currency: context.areaVariables?.priceVariant?.currency }),
    });

  const formatSubscriptionPrice = (
    subscriptionPeriodPricing?: SubscriptionPeriodPricingFragment | null,
    options?: Intl.NumberFormatOptions,
  ): string =>
    getFormattedPriceForSubscriptionPeriod(context.locale, subscriptionPeriodPricing, {
      ...options,
      ...(options?.currency ? {} : { currency: context.areaVariables?.priceVariant?.currency }),
    });

  return { formatCurrency, formatSubscriptionPrice };
};
